import { render, staticRenderFns } from "./DRoute.vue?vue&type=template&id=5f8fbfba&scoped=true"
import script from "./DRoute.vue?vue&type=script&lang=js"
export * from "./DRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8fbfba",
  null
  
)

export default component.exports